/**
 * Lightweight conversion events. Pushes to window.dataLayer when present.
 * Does not load a new analytics vendor.
 */
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || !name) return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      ...params,
    });
  } catch {
    // no-op
  }
}
